import {
  DropdownIndicator,
  formatGroupLabel,
  getTranslatedText,
  IndicatorSeparator
} from '@nile/components';
import { FrequencyDurationUnit } from '@nile/types';
import {
  DisplayText,
  Dropdown,
  Label,
  PositiveNumberField
} from '@superops/ui-design-system';
import React from 'react';
import { FormattedMessage, IntlShape, useIntl } from 'react-intl';
import { FREQUENCY_DURATION_UNITS } from '../constants';
import { SVGIcon } from '@superops/super-icons';
import { MinimalDropDown } from './MinimalDropDown';

const maxRepeatInterval: Record<FrequencyDurationUnit, number> = {
  DAY: 31,
  WEEK: 4,
  MONTH: 12,
  YEAR: 10
};

interface FrequencySelectFieldProps {
  frequencyDurationUnit?: FrequencyDurationUnit;
  frequencyInterval?: number;
  onChange: (updateObject) => void;
  isDisabled?: boolean;
}

const FrequencySelectField = ({
  frequencyDurationUnit = 'MONTH',
  frequencyInterval,
  onChange,
  isDisabled
}: FrequencySelectFieldProps) => {
  const intl: IntlShape = useIntl();

  const subscriptionTypes = FREQUENCY_DURATION_UNITS.map((unit) => {
    return {
      ...unit,
      label: getTranslatedText(intl, unit?.label)
    };
  });

  let subscriptionType = subscriptionTypes.find((el) => {
    return el.value === frequencyDurationUnit;
  });

  if (!subscriptionType) {
    subscriptionType = subscriptionTypes.find((el) => {
      return el.value === 'MONTH';
    });
  }

  return (
    <div className="fx actr g10">
      <DisplayText size="large">
        <FormattedMessage id="msp.contracts.form.field.subscription.period" />
      </DisplayText>
      <span className="fx actr">
        <SVGIcon name="Frequency" />
        <PositiveNumberField
          value={frequencyInterval?.toString()}
          onChange={(val) => {
            onChange({ frequencyInterval: parseInt(val) });
          }}
          onBlur={() => {
            if (frequencyInterval < 1) {
              onChange({ frequencyInterval: 1 });
            }
          }}
          label="Frequency unit"
          labelHidden
          autoComplete="off"
          type="number"
          min={1}
          placeholder="1"
          max={maxRepeatInterval[frequencyDurationUnit]}
          disabled={isDisabled}
          size="extrasmall"
        />
        <span className="w100p noborder">
          <MinimalDropDown
            name="subscriptionTypes"
            value={subscriptionType}
            onChange={(option: { label: string; value: string }) => {
              onChange({
                frequencyDurationUnit: option?.value || 'MONTH',
                billingOffset: 0
              });
            }}
            options={subscriptionTypes}
            placeholder={getTranslatedText(
              intl,
              'admin.serviceCatalog.subscriptionType.custom.type.placeholder'
            )}
            isDisabled={isDisabled}
          />
        </span>
      </span>
    </div>
  );
};

export { FrequencySelectField };
